/**
 * Admin
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import {  HttpHeaders, HttpParams,
          HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { RaceWagerType } from '../model/raceWagerType';
import { RaceWagerTypePagination } from '../model/raceWagerTypePagination';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


import { JtHttp, HttpResponse } from '../../JtHttp';

@Injectable()
export class RaceWagerTypeService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: JtHttp, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param orderBy 
     * @param orderByDesc 
     * @param page 
     * @param size 
     * @param raceId 
     * @param xVersion 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminRaceWagerTypeAllGet(orderBy?: string, orderByDesc?: boolean, page?: number, size?: number, raceId?: number, xVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<RaceWagerTypePagination>;
    public apiAdminRaceWagerTypeAllGet(orderBy?: string, orderByDesc?: boolean, page?: number, size?: number, raceId?: number, xVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RaceWagerTypePagination>>;
    public apiAdminRaceWagerTypeAllGet(orderBy?: string, orderByDesc?: boolean, page?: number, size?: number, raceId?: number, xVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RaceWagerTypePagination>>;
    public apiAdminRaceWagerTypeAllGet(orderBy?: string, orderByDesc?: boolean, page?: number, size?: number, raceId?: number, xVersion?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orderBy !== undefined && orderBy !== null) {
            queryParameters = queryParameters.set('orderBy', <any>orderBy);
        }
        if (orderByDesc !== undefined && orderByDesc !== null) {
            queryParameters = queryParameters.set('orderByDesc', <any>orderByDesc);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (raceId !== undefined && raceId !== null) {
            queryParameters = queryParameters.set('raceId', <any>raceId);
        }

        let headers = this.defaultHeaders;
        if (xVersion !== undefined && xVersion !== null) {
            headers = headers.set('X-Version', String(xVersion));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RaceWagerTypePagination>('get',`${this.basePath}/api/Admin/RaceWagerType/All`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param xVersion 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminRaceWagerTypeIdDelete(id: number, xVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiAdminRaceWagerTypeIdDelete(id: number, xVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiAdminRaceWagerTypeIdDelete(id: number, xVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiAdminRaceWagerTypeIdDelete(id: number, xVersion?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling apiAdminRaceWagerTypeIdDelete.');
        }


        let headers = this.defaultHeaders;
        if (xVersion !== undefined && xVersion !== null) {
            headers = headers.set('X-Version', String(xVersion));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/Admin/RaceWagerType/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param xVersion 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiAdminRaceWagerTypePost(body?: RaceWagerType, xVersion?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiAdminRaceWagerTypePost(body?: RaceWagerType, xVersion?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiAdminRaceWagerTypePost(body?: RaceWagerType, xVersion?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiAdminRaceWagerTypePost(body?: RaceWagerType, xVersion?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (xVersion !== undefined && xVersion !== null) {
            headers = headers.set('X-Version', String(xVersion));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/Admin/RaceWagerType`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
